import * as d3 from "d3"
import { ButtonDatum, ButtonSelection } from "./types"

export const button = (buttonToSelect: any, extendSelection = false) => {
  if (extendSelection && buttonToSelect?.classed("selected")) {
    return
  }
  if (!extendSelection) {
    d3.select("#svg-dashboard")
      .selectAll("g.playerdash-dashboard-button")
      .classed("selected", false)
  }
  buttonToSelect?.classed("selected", true)
}

export const toggle = (buttonToSelect: any) => {
  buttonToSelect?.classed("selected", !buttonToSelect?.classed("selected"))
}

export const getSelection = (): ButtonSelection | undefined => {
  const selectedButtons = d3
    .select<HTMLElement, any>("#svg-dashboard")
    ?.selectAll<SVGGElement, ButtonDatum>("g.playerdash-dashboard-button.selected")
  return selectedButtons?.size() ? selectedButtons : undefined
}

export const getNonSelection = (): ButtonSelection => {
  return d3
    .select<HTMLElement, any>("#svg-dashboard")
    .selectAll<SVGGElement, ButtonDatum>("g.playerdash-dashboard-button:not(.selected)")
}

export const isSelected = (button: ButtonSelection) => {
  return button.classed("selected")
}
